import { createFileRoute } from '@tanstack/react-router'

import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import { SecretsPanel } from '@/components/secrets/secrets-panel'
import { matching, readSearch, text } from '@/lib/search-params'

const SHAPE = {
  /** 1.72.1 : la fiche d'un secret, le `web_path` des refus `human_gesture_required`. */
  secret: text(),
  /** 1.83.0 (lot 40) : le dossier du coffre ouvert ; la vue se partage. */
  dossier: matching(/^[0-9a-f]{24}$/),
  /** 1.84.0 (lot 41) : la fiche d'une demande d'accès, `web_path` de ses refus. */
  demande: text(),
}

export const Route = createFileRoute('/_app/clients/$clientId/secrets')({
  validateSearch: (search: Record<string, unknown>) => readSearch(SHAPE, search),
  component: ClientSecretsPage,
})

function ClientSecretsPage() {
  const client = useShellClient()
  const { secret, dossier, demande } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <Frame>
      <SecretsPanel
        clientId={client.id}
        openId={secret}
        onOpen={(next) => {
          void navigate({ search: (current) => ({ ...current, secret: next }) })
        }}
        folderId={dossier}
        onFolder={(next) => {
          void navigate({ search: (current) => ({ ...current, dossier: next }) })
        }}
        requestId={demande}
        onOpenRequest={(next) => {
          void navigate({ search: (current) => ({ ...current, demande: next }) })
        }}
      />
    </Frame>
  )
}
